/**
 * [INPUT]: 依赖 React context/use，消费 cartesian 或 polar controller 对外暴露的 common contract
 * [OUTPUT]: 对外提供 CommonChartContext 与 useCommonChart 边界守卫
 * [POS]: Legend/Tooltip 跨图表家族的最小共享上下文
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
"use client";
import { createContext, use } from "react";

export const CommonChartContext = createContext(null)

export function useCommonChart() {
  const ctx = use(CommonChartContext)
  if (!ctx) {
    throw new Error("<Legend /> / <Tooltip /> must be used within a chart root.")
  }
  return ctx
}
